import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsEBikeRideNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M27.078 1.198L23.24 7.231a.5.5 0 00.422.769H27v3.533c0 .5.653.69.922.268l3.839-6.033A.5.5 0 0031.339 5H28V1.467c0-.5-.653-.69-.922-.269zM17.164 9.63A1.25 1.25 0 0118.25 9H24v2.5h-3.558l2.884 4.872a6.5 6.5 0 11-2.15 1.275l-1.142-1.928-4.347 7.648A1.25 1.25 0 0114.6 24h-1.774a6.5 6.5 0 11-4.495-7.738L9.705 13.5H6V11h7v2.5h-.603l2.819 5.637 3.351-5.897-1.393-2.354a1.25 1.25 0 01-.01-1.255zM8.518 21.5h5.084l-2.549-5.098zm-1.33-2.941A4 4 0 1010.208 24H6.501a1.25 1.25 0 01-1.12-1.807zm15.301 1.307a4 4 0 102.151-1.274l2.572 4.347-2.151 1.273z" />
      </g>
    </svg>
  )
);
SvgSportsEBikeRideNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsEBikeRideNormalMedium;
